const uaTester = {
  Android: /Android/,
  auPAY: /auWALLET/,
  iOS: /iPhone|iPad|iPod/,
  WeChat: /MicroMessenger/,
  LINE: /Line/,
  PayPay: /jp\.pay2\.app/,
  UnionPay: /UnionPay/,
}

export function uaIs(platform: keyof typeof uaTester) {
  return uaTester[platform].test(navigator.userAgent)
}
